import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { Grid, Paper, Typography, Box } from '@mui/material';

const Dashboard = () => {
    const [stats, setStats] = useState({
        sales_today: 0,
        active_repairs: 0,
        low_stock_items: 0,
        repairs_awaiting_parts: 0
    });

    useEffect(() => {
        const fetchStats = async () => {
            try {
                const response = await api.get('/reports/dashboard');
                if (response.data.success) {
                    setStats(response.data.data);
                }
            } catch (error) {
                console.error("Error fetching stats", error);
            }
        };
        fetchStats();
    }, []);

    const StatCard = ({ title, value, color }) => (
        <Paper elevation={2} sx={{ p: 2, display: 'flex', flexDirection: 'column', height: 140, borderLeft: `5px solid ${color}` }}>
            <Typography color="textSecondary" gutterBottom variant="h6">
                {title}
            </Typography>
            <Typography component="p" variant="h3" sx={{ flexGrow: 1, fontWeight: 'bold' }}>
                {value}
            </Typography>
        </Paper>
    );

    return (
        <Box>
            <Typography variant="h4" gutterBottom>Dashboard</Typography>
            <Grid container spacing={3}>
                <Grid item xs={12} md={3}>
                    <StatCard title="Ventas Hoy" value={`$${stats.sales_today}`} color="#4caf50" />
                </Grid>
                <Grid item xs={12} md={3}>
                    <StatCard title="Reparaciones Activas" value={stats.active_repairs} color="#2196f3" />
                </Grid>
                <Grid item xs={12} md={3}>
                    <StatCard title="Stock Bajo" value={stats.low_stock_items} color="#f44336" />
                </Grid>
                <Grid item xs={12} md={3}>
                    <StatCard title="Esperando Piezas" value={stats.repairs_awaiting_parts} color="#ff9800" />
                </Grid>
            </Grid>
        </Box>
    );
};

export default Dashboard;
